module.exports = __webpack_public_path__ + "static/images/returned.1SjonqF.svg";